import { render } from "./VistaCurso.vue?vue&type=template&id=2a14eed4&scoped=true"
import script from "./VistaCurso.vue?vue&type=script&lang=js"
export * from "./VistaCurso.vue?vue&type=script&lang=js"

import "./VistaCurso.vue?vue&type=style&index=0&id=2a14eed4&scoped=true&lang=css"

import exportComponent from "D:\\WEB\\LICEO\\CURSOS\\portalalumnoscursos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a14eed4"]])

export default __exports__